import { ReactComponent as CheckIcon } from 'assets/icon/check.svg';

const CheckBox = ({ checked = false, onChange = (data: boolean) => {}, disabled = false }) => {
  const handleOnChange = () => {
    onChange(!checked);
  };
  return (
    <label
      className={`flex items-center justify-center cursor-pointer relative ${
        disabled ? 'pointer-events-none' : ''
      }`}
      htmlFor="checkbox-id"
    >
      <input
        className="appearance-none h-4 w-4 border-2 rounded-1 border-grey2 
        hover:border-active hover:bg-grey1 checked:bg-grey1 checked:border-active cursor-pointer"
        type="checkbox"
        checked={checked}
        onChange={handleOnChange}
      />
      <div
        className={`absolute cursor-pointer top-0 left-0 ${checked ? 'flex' : 'hidden'}`}
        onClick={handleOnChange}
      >
        <CheckIcon className={`text-4xl font-semibold h-4 w-4 absolute`} color="#337B9E" />
      </div>
    </label>
  );
};

export default CheckBox;
